var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("label", [_vm._v("Карта для предоплаты")]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedCard.card_id,
              expression: "selectedCard.card_id",
            },
          ],
          staticClass: "form-control",
          attrs: { disabled: "" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.selectedCard,
                "card_id",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            },
          },
        },
        [
          _c("option", { attrs: { disabled: "", value: "0" } }, [
            _vm._v("Выберите карту"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.cards, function (c) {
            return c.status === 1
              ? _c(
                  "option",
                  { domProps: { value: c.id } },
                  [
                    _vm._v("[" + _vm._s(c.id) + "]\n      "),
                    c.type === 5
                      ? [
                          _c("span", [
                            _vm._v("QiWi кошелек " + _vm._s(c.number)),
                          ]),
                        ]
                      : [
                          _c("span", [
                            _vm._v(_vm._s(_vm.printNumber(c.number))),
                          ]),
                        ],
                    _vm._v(
                      "\n      (" +
                        _vm._s((c.owner && c.owner.short_name) || "не указан") +
                        ") "
                    ),
                    c.balance
                      ? _c("span", [_vm._v("[" + _vm._s(c.balance) + "]")])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e()
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("label", [_vm._v("Сумма для предоплаты")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedCard.sum,
            expression: "selectedCard.sum",
          },
        ],
        staticClass: "form-control",
        attrs: {
          disabled: true,
          placeholder: "Сумма для предоплаты",
          type: "number",
        },
        domProps: { value: _vm.selectedCard.sum },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.selectedCard, "sum", $event.target.value)
            },
            _vm.updatePrice,
          ],
        },
      }),
      _vm._v(" "),
      _vm.priceCorrectionBlock
        ? [
            _vm.allowToMakeDiscount
              ? _c("div", { staticClass: "mt-1 mb-1" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedCard.options.payFull,
                        expression: "selectedCard.options.payFull",
                      },
                    ],
                    attrs: { id: "check_2", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.selectedCard.options.payFull)
                        ? _vm._i(_vm.selectedCard.options.payFull, null) > -1
                        : _vm.selectedCard.options.payFull,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.selectedCard.options.payFull,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.selectedCard.options,
                                "payFull",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.selectedCard.options,
                                "payFull",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.selectedCard.options, "payFull", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "pointer", attrs: { for: "check_2" } },
                    [_vm._v("Заявка оплачена полностью (сделать скидку)")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.selectedCard.options.payFull && _vm.overPrice
              ? _c("div", { staticClass: "alert alert-info" }, [
                  _c("p", [
                    _vm._v("Курьеру нужно получить "),
                    _c("strong", [_vm._v(_vm._s(_vm.overPrice))]),
                    _vm._v("р наличными"),
                  ]),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }